import React from "react";
import Footer from "./Footer";
import HelpContent from "./HelpContent";

const Help = () => {
  return (
    <>

      <HelpContent />

      <Footer />
    </>
  );
};

export default Help;